import { defaultThemeColors } from './colors';
import { defaultThemeFonts } from './fonts';

export const defaultTheme = {
	colors: defaultThemeColors,
	fonts: defaultThemeFonts,
};
